import Vue from "vue";

export function updateMerchantDetailCompanyNameApi(params, success, complete) {
    let url = "/admin/web/merchantDetail/updateMerchantDetailCompanyName";
    Vue.prototype.alexPost(url, params, success, null, complete);
}





